import React, { useContext } from 'react';
import './dashBoard.css';
import { Col, Container, Row } from 'react-bootstrap';
import { DashBoardContext } from '../DashBoardView';
import TableContent from '../../../components/TableDataContent/TableContent';
import ContentData from '../../../constants/contentFile.json';
import SearchData from '../../../components/SearchComponent/SearchData';
import SuccessPopupAlert from '../../../components/PopupAlertSuccess/PopupAlert';
import ErrorPopup from '../../../components/PopupAlertError/PopupAlertError';
import DownloadIcon from '../../../assets/images/icons/download.svg';
import Loader from '../../../components/Loader/Loader';

import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  ArcElement,
  Tooltip,
  Legend,
  PointElement,
  BubbleController,
} from 'chart.js';
import { Bar, Doughnut } from 'react-chartjs-2';

import ThemeSelect from '../../../components/ThemeSelectOption/SelectOption';

ChartJS.register(
  BarElement,
  ArcElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  PointElement,
  BubbleController,
);

const DashBoard = () => {
  const {
    data,
    options,
    dataProducts,
    optionsProducts,
    centerValue,
    handleYearChange,
    selectedYear,
    yearList,
    centerValueBattery,
    centerValueCombo,
    optionsBattery,
    optionsCombo,
    dataProductsCombo,
    dataProductsBattery,
    userData,
    onPageChange,
    pageCount,
    totalPage,
    searchData,
    onChangeSearch,
    successAlertShow,
    successAlertMessage,
    setSuccessAlertShow,
    errorPopup,
    errorPopupMessage,
    setErrorPopup,
    statusValue,
    handleDownload,
    spinnerStatus,
  } = useContext(DashBoardContext);

  const header = [
    { title: 'NAME', prop: 'name' },
    { title: 'PHONE', prop: 'phone' },
    { title: 'EMAIL', prop: 'email' },
    { title: 'STATE', prop: 'state' },
    { title: 'CITY', prop: 'city' },
  ];

  console.log(centerValueCombo, 'centerValueCombo');

  return (
    <div className="pageBg">
      <div className="breadCrums boldBreadCrums">
        <span>{ContentData.dashBoard.dashBoard}</span>
      </div>
      <Container>
        <div className="pageTittles-admin-list">
          {ContentData.dashBoard.dashBoard}
        </div>
        <Row>
          <Col md="12" sm="12">
            <div className="appVisitorChart">
              <div className="subChartHead">
                <h3>{ContentData.dashBoard.appVisitors}</h3>
                <div className="appVisitorDropdown">
                  <ThemeSelect
                    selectPlaceholder={'Select'}
                    values={yearList}
                    selectNum={'_id'}
                    label={'name'}
                    handleSelectData={handleYearChange}
                    defaultValue={selectedYear}
                  />
                </div>
              </div>
              <div
                style={{ width: '100%', height: '350px', position: 'relative' }}
              >
                <Bar data={data} options={options} />
              </div>
            </div>
          </Col>
          <Col md="4" sm="12">
            <div className="appVisitorChart">
              <div className="subChartHead">
                <h3>{ContentData.dashBoard.InverterRecomendations}</h3>
              </div>
              <div className="daughnutChart">
                <Doughnut data={dataProducts} options={optionsProducts} />
                <div className="daughnutValues">
                  <div className="subTextChart">
                    <span>{centerValue.value}</span>
                  </div>
                </div>
              </div>
              <div className="subTextChart">
                <p>{centerValue?.label ? centerValue?.label?.toUpperCase() : ''}</p>
              </div>
            </div>
          </Col>
          <Col md="4" sm="12">
            <div className="appVisitorChart">
              <div className="subChartHead">
                <h3>{ContentData.dashBoard.BatteryRecomendations}</h3>
              </div>
              <div className="daughnutChart">
                <Doughnut data={dataProductsBattery} options={optionsBattery} />
                <div className="daughnutValues">
                  <div className="subTextChart">
                    <span>{centerValueBattery.value}</span>
                  </div>
                </div>
              </div>
              <div className="subTextChart">
                <p>{centerValueBattery?.label ? centerValueBattery?.label?.toUpperCase() : ''}</p>
              </div>
            </div>
          </Col>
          <Col md="4" sm="12">
            <div className="appVisitorChart">
              <div className="subChartHead">
                <h3>{ContentData.dashBoard.ComboRecomendations}</h3>
              </div>
              <div className="daughnutChart">
                <Doughnut data={dataProductsCombo} options={optionsCombo} />
                <div className="daughnutValues">
                  <div className="subTextChart">
                    <span>{centerValueCombo.value}</span>
                  </div>
                </div>
              </div>
              <div className="subTextChart">
                <p>{centerValueCombo?.label ? centerValueCombo?.label?.toUpperCase() : ''}</p>
              </div>
            </div>
          </Col>
        </Row>
        <div className="userDetails">
          {spinnerStatus && <Loader />}
          <div className="pageTittles-admin-list subChartHeadTable">
            <h3>{ContentData.dashBoard.userdetails}</h3>
          </div>
          <div className="search-add-section">
            <div className="search-box">
              <SearchData
                placeholder={ContentData.dashBoard.searchData}
                value={searchData}
                onChange={onChangeSearch}
                type="text"
              />
            </div>
            <div className="plusRefreshDtat">
              <div
                className="download-btn"
                onClick={() => handleDownload(searchData)}
              >
                Download User Details
                <img src={DownloadIcon} alt="download" />
              </div>
            </div>
          </div>
          <div className="userDetails basicContainer">
            <div className=" adminTable roleListTable">
              <TableContent
                tableData={userData}
                header={header}
                onPageChange={e => onPageChange(e)}
                isPagination={true}
                currentPage={pageCount}
                pageCount={totalPage}
              />
            </div>
          </div>
          <SuccessPopupAlert
            show={successAlertShow}
            alertMessage={successAlertMessage}
            handleSubmit={() => setSuccessAlertShow(false)}
          />
        </div>
        <ErrorPopup
          show={errorPopup}
          alertMessage={errorPopupMessage}
          buttonText={ContentData.tenantPage.tryAgain}
          status={statusValue}
          handleCancel={() => setErrorPopup(false)}
          handleSubmit={() => setErrorPopup(false)}
          errorAlertOnly={statusValue === 400 ? true : false}
        />
      </Container>
    </div>
  );
};

export default DashBoard;
